import React, { useState } from 'react';
import { useTranslate, useDataProvider } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles'
import { Box, Dialog, DialogContent, Typography, ListItem, Button, CircularProgress } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomTextField from '../CustomizedUIs/CustomTextFiled'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import { Close } from '@material-ui/icons'
import { red, pink } from '@material-ui/core/colors';
import TextButton from '../CustomizedUIs/TextButton';
const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    dialogPaper: {

        minHeight: '40vh',
        maxHeight: '40vh',
        backgroundColor: theme.palette.background.default
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    btnClose: {
        width: '28px',
        height: '28px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        padding: 0
    },
    textClose: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.4px',
        color: '#4f5064',
    },
    titleRoom: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
}))


const EditClusterDialog = ({ open, handleClose, infoChannel, ...props }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [inheritFrom, setInheritFrom] = useState(false);
    const [openInherit, setOpenInherit] = useState(false);
    const [inherit, setInherit] = useState({ name: '' });
    const [infoChannels, setInfoChannels] = useState()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('')
    const [textValue, setTextValue] = React.useState({
        channelName: '',
    });

    const [validate, setValidate] = React.useState({
        channelName: {
            isError: true,
            message: ''
        }
    });


    const onChangeInheritFrom = () => {
        setInheritFrom(!inheritFrom)

    }

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        setValidate({
            ...validate, [prop]: e.target.value.length === 0 ? {
                isError: true, message: 'required'
            } : {
                    isError: false, message: ''
                }
        })
    }


    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClickOpenInherit = () => {
        setOpenInherit(!openInherit)
    }

    const onChangeInherit = (value) => {
        setInherit(value)
        setOpenInherit(false)
    }

    const onSave = () => {
        setLoading(true)
        var data = { name: textValue.channelName.trim() }
        if (inherit)
            data.inheritfrom = inherit.id
        dataProvider('UPDATE', "infochannels", {
            id: infoChannel,
            data
        })
            .then(() => {
                handleClose()
                setLoading(false)
            })
            .catch(error => {
                if (error.message === 'channel name is exist!')
                    setError('Name exist')
                else
                    setError('Create failed')
                setLoading(false)
            })

    }

    const getListInfoChannel = () => {

        dataProvider('GET_LIST', "infochannels", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setInfoChannels(data);
                setTextValue({
                    ...textValue, channelName: data.find(element => element.id === infoChannel).name
                })
                data.find(element => element.id === infoChannel).inherit && setInherit(data.find(element => element.id === data.find(element => element.id === infoChannel).inherit))
            })
            .catch(error => {

            })
    }

    React.useEffect(() => {
        if (open) {
            setInherit({ name: '' })
            getListInfoChannel()
        }

    }, [open])

    if (!infoChannels) return null

    return (
        <Dialog open={open} scroll='paper' classes={{ paper: classes.dialogPaper }}>
            <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
                <IconRadiusButton className={classes.btnClose} onClick={handleClose}>
                    <Close color='primary' />
                </IconRadiusButton>
            </Box>
            <Box mb={2} ml={3}>
                <Typography className={classes.titleRoom} style={{ paddingBottom: 8 }}> {translate(`pos.infochannel.editChannel`)}</Typography>
            </Box>
            <DialogContent>
                {
                    error != "" && (
                        <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                            <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{error}</Typography>
                        </Box>
                    )
                }
                <Box my={1}>
                    <CustomTextField
                        required
                        onBlur={textOnChange('channelName')}
                        id="filled-basic"
                        label={translate(`pos.infochannel.name`)}
                        value={textValue.channelName}
                        error={validate.channelName.message != "" && validate.channelName.isError}
                        helperText={validate.channelName.message}
                        onChange={textOnChange('channelName')}
                        style={{ width: 500 }}
                        endDom={
                            <CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.infochannel.TitleChannelName`)}
                                content={translate(`pos.infochannel.ConstentChannelName`)}
                                icon={<b>?</b>}
                            />
                        } />
                </Box>
                <Box pt={1} pb={0} mt={1} >
                    <SelectBox
                        label={translate(`pos.infochannel.inheritFrom`)}
                        value={inherit.name}
                        open={openInherit}
                        handleClick={handleClickOpenInherit}
                    >
                        <Box className={classes.boxBoder} >
                            {
                                infoChannels.map(value => (
                                    <ListItem key={value.id} style={{ padding: '8px' }} button onClick={() => onChangeInherit(value)}>
                                        <Typography className={classes.TexTSelect} >{value.name}</Typography>
                                    </ListItem>
                                ))
                            }
                        </Box>
                    </SelectBox>
                </Box>
                <Box display='flex' justifyContent='flex-end'>
                    <Box display='flex' alignItems='flex-end' mt={3}  >
                        <TextButton style={{ marginRight: '30px' }} onClick={handleClose}/>
                           
                        <Button variant="contained" color='primary' size='large'
                            onClick={onSave}
                        >
                            {loading ? (
                                <CircularProgress
                                    size={20}
                                    thickness={2}
                                    color='inherit'
                                />
                            ) : <Typography className={classes.btnCreate}>  {translate(`pos.infochannel.save`)}</Typography>}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog >
    )
}
export default EditClusterDialog